// Riferimento API Velo: https://www.wix.com/velo/reference/api-overview/introduction

$w.onReady(function () {

	// Scrivi il codice Javascript qui usando l'API Velo di riferimento

	// Stampa Hello world:
	// console.log("Hello world!");

	// Funzioni di chiamata sugli elementi della pagina, ad es.:
	// $w("#button1").label = "Click me!";

	// Clicca su "Run" o visualizza l'anteprima del sito per eseguire il codice

});

/**
*	Adds an event handler that runs when the element is clicked.
	[Read more](https://www.wix.com/corvid/reference/$w.ClickableMixin.html#onClick)
*	 @param {$w.MouseEvent} event
*/
export function section1_click(event) {
	// This function was added from the Properties & Events panel. To learn more, visit http://wix.to/UcBnC-4
	// Add your code for this event here: 
}cart.getCurrentCart().then((currentCart) => {
		const cartId = currentCart._id;
        const cartLineItems = currentCart.lineItems;

    }).catch((error) => {
		console.error(error);
    });
	